module.exports = __webpack_public_path__ + "img/door-closed.554fdb04.svg";